import {
  MarcoClient,
  MarcoStatusDTO,
  MarcoScoreInfo,
  ScoreDTO,
  SendDisputedScoreDetailDTO,
  DisputedScoresIds,
  AlertDTO,
  SendToMarcoDetailDTO,
  SendforTrainingRequestDetailDTO,
  MarcoTrainingAndImprovementStatusDTO,
  SendAllPlatesToMarcoDetailDTO,
  MarcoPlateInfoDto,
} from 'business/models/Models';
import ModelFactory from 'business/models/ModelFactory';
import BaseService from './BaseService';

export default class MarcoService extends BaseService {
  async getMarcoStatus() {
    const _marcoClient: MarcoClient = ModelFactory(MarcoClient, false, true);
    const marcoStatus: MarcoStatusDTO = await _marcoClient.getMarcoStatus();
    return marcoStatus;
  }
  async getMarcoScoreInfo(
    plateId: number,
    imageBatchId: number,
    wellNumber: number,
    dropNumber: number,
  ): Promise<MarcoScoreInfo[]> {
    const _marcoClient: MarcoClient = ModelFactory(MarcoClient, false, true);
    const marcoScoreInfo = await _marcoClient.getMarcoScoreInfo(
      plateId,
      imageBatchId,
      wellNumber,
      dropNumber,
    );

    return marcoScoreInfo;
  }

  async SendToMarco(
    plateId: number,
    imageBatchId: number,
    dropNumber: number,
    overwriteUnsentDisputedScores: boolean,
  ): Promise<AlertDTO> {
    const _marcoClient: MarcoClient = ModelFactory(MarcoClient, false, true);
    const sendToMarcoDetails: SendToMarcoDetailDTO = new SendToMarcoDetailDTO();
    sendToMarcoDetails.plateId = plateId;
    sendToMarcoDetails.imageBatchId = imageBatchId;
    sendToMarcoDetails.dropNumber = dropNumber;
    sendToMarcoDetails.overwriteUnsentDisputedScores = overwriteUnsentDisputedScores;
    const sendToMarcoResponse: AlertDTO = await _marcoClient.sendToMarco(
      sendToMarcoDetails,
    );
    return sendToMarcoResponse;
  }

  async SendForTraining(inspectionID: number): Promise<AlertDTO> {
    const _marcoClient: MarcoClient = ModelFactory(MarcoClient, false, true);
    const sendForTrainingDetails: SendforTrainingRequestDetailDTO =
      new SendforTrainingRequestDetailDTO();
    sendForTrainingDetails.inspectionID = inspectionID;
    const sendForTrainingResponse: AlertDTO = await _marcoClient.sendForTraining(
      sendForTrainingDetails,
    );
    return sendForTrainingResponse;
  }

  async GetNonDisputedScores(
    plateId: number,
    imageBatchId: number,
    wellNumber: number,
    dropNumber: number,
  ): Promise<ScoreDTO[]> {
    const _marcoClient: MarcoClient = ModelFactory(MarcoClient, false, true);
    const nonDisputedScores: ScoreDTO[] = await _marcoClient.getNonDisputedScores(
      imageBatchId,
      plateId,
      wellNumber,
      dropNumber,
    );
    return nonDisputedScores;
  }

  async SendDisputedScore(
    disputedScoresIds: DisputedScoresIds[],
    recomendedScore: number,
    disputeReason: string,
  ): Promise<boolean> {
    const _marcoClient: MarcoClient = ModelFactory(MarcoClient, false, true);
    const disputedScoreDetails: SendDisputedScoreDetailDTO =
      new SendDisputedScoreDetailDTO();
    disputedScoreDetails.disputedScoresIds = disputedScoresIds;
    disputedScoreDetails.recomendedScore = recomendedScore;
    disputedScoreDetails.disputeReason = disputeReason;
    const disputedScoreResponse: boolean = await _marcoClient.sendDisputedScore(
      disputedScoreDetails,
    );
    return disputedScoreResponse;
  }

  async GetMarcoTrainingAndImprovementStatus(): Promise<boolean> {
    const _marcoClient: MarcoClient = ModelFactory(MarcoClient, false, true);
    const collectRetrainingImages =
      await _marcoClient.getMarcoTrainingAndImprovementStatus();
    return collectRetrainingImages;
  }

  async SetMarcoTrainingAndImprovementStatus(
    collectRetrainingImages: boolean,
    autoCollectRetrainingImages: boolean,
  ) {
    const marcoTrainingAndImprovementStatusDetails: MarcoTrainingAndImprovementStatusDTO =
      new MarcoTrainingAndImprovementStatusDTO();
    marcoTrainingAndImprovementStatusDetails.autoCollectRetrainingImages =
      autoCollectRetrainingImages;
    marcoTrainingAndImprovementStatusDetails.collectRetrainingImages =
      collectRetrainingImages;
    const _marcoClient: MarcoClient = ModelFactory(MarcoClient, false, true);
    await _marcoClient.setMarcoTrainingAndImprovementStatus(
      marcoTrainingAndImprovementStatusDetails,
    );
  }

  async sendToMarcoFromExplorer(treeNodeId: number): Promise<number> {
    const _marcoClient: MarcoClient = ModelFactory(MarcoClient, false, true);
    const sendAllPlatesToMarcoDetails: SendAllPlatesToMarcoDetailDTO =
      new SendAllPlatesToMarcoDetailDTO();
    sendAllPlatesToMarcoDetails.treeNodeId = treeNodeId;
    return await _marcoClient.sendAllPlatesToMarco(sendAllPlatesToMarcoDetails);
  }

  async sendAllPlatesToScore(plateIDs: number[]): Promise<number> {
    const _marcoClient: MarcoClient = ModelFactory(MarcoClient, false, true);
    const sendAllPlatesToMarcoDetails: SendAllPlatesToMarcoDetailDTO =
      new SendAllPlatesToMarcoDetailDTO();
    return await _marcoClient.sendAllPlatesToMarcoByPlateIDs(plateIDs);
  }

  async isMarcoModelAvailable(): Promise<boolean> {
    const _marcoClient: MarcoClient = ModelFactory(MarcoClient, false, true);
    return await _marcoClient.checkIsMarcoModelAvailable();
  }

  async isAutoScoredAllowed(plateID: number): Promise<MarcoPlateInfoDto> {
    const _marcoClient: MarcoClient = ModelFactory(MarcoClient, false, true);
    return await _marcoClient.getMarcoPlateInfo(plateID);
  }
}
